import { BlockStack, Card, Layout, Box, SkeletonPage, SkeletonBodyText, SkeletonDisplayText, InlineStack, InlineGrid } from "@shopify/polaris";

export default function DashboardSkeleton() {
  return (
    <SkeletonPage title="Nudgesmart Dashboard" fullWidth>
      <Layout>
        {/* Main Content (2/3) - Analytics + Active Campaigns */}
        <Layout.Section variant="twoThirds">
          <BlockStack gap="400">
            {/* Analytics Overview Skeleton */}
            <Card>
              <Box padding="400">
                <BlockStack gap="400">
                  <InlineStack align="space-between">
                    <SkeletonDisplayText size="small" />
                    <SkeletonDisplayText size="small" />
                  </InlineStack>
                  <InlineGrid columns={4} gap="400">
                    <Box><SkeletonBodyText lines={2} /></Box>
                    <Box><SkeletonBodyText lines={2} /></Box>
                    <Box><SkeletonBodyText lines={2} /></Box>
                    <Box><SkeletonBodyText lines={2} /></Box>
                  </InlineGrid>
                </BlockStack>
              </Box>
            </Card>

            {/* Active Campaigns Skeleton */}
            <Card>
              <Box padding="400">
                <BlockStack gap="400">
                  <InlineStack align="space-between">
                    <SkeletonDisplayText size="small" />
                    <SkeletonDisplayText size="small" />
                  </InlineStack>
                  <SkeletonBodyText lines={1} />
                  <SkeletonBodyText lines={4} />
                </BlockStack>
              </Box>
            </Card>
          </BlockStack>
        </Layout.Section>

        {/* Sidebar (1/3) - What's New + Support + Summary */}
        <Layout.Section variant="oneThird">
          <BlockStack gap="400">
            {/* What's New Skeleton */}
            <Card>
              <Box padding="400">
                <BlockStack gap="300">
                  <SkeletonDisplayText size="small" />
                  <SkeletonBodyText lines={3} />
                </BlockStack>
              </Box>
            </Card>

            {/* Support Hub Skeleton */}
            <Card>
              <Box padding="400">
                <BlockStack gap="300">
                  <SkeletonDisplayText size="small" />
                  <SkeletonBodyText lines={2} />
                </BlockStack>
              </Box>
            </Card>

            {/* Campaign Summary Skeleton */}
            <Card>
              <Box padding="400">
                <BlockStack gap="300">
                  <SkeletonDisplayText size="small" />
                  <SkeletonBodyText lines={3} />
                </BlockStack>
              </Box>
            </Card>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
